import { createTransform } from 'redux-persist';

const AddRehydratedTransform = createTransform(
  () => true,
  state => state,
  { whitelist: ['rehydrated'] },
);

export default AddRehydratedTransform;
